import { useMergeGuestFavorites } from '../api'

/**
 * Невидимый участник каркаса: после входа доливает избранное гостя на сервер.
 * Без флага или на mock ничего не делает (`useMergeGuestFavorites`).
 */
export function FavoritesMerge() {
  useMergeGuestFavorites()
  return null
}
